import tw from "twin.macro"
import { ModelHighlightsModuleProps } from "./ModelHighlightsModuleProps"
import { parseDisclaimerBlocks } from "../../../../helpers"
import { toggleDisclaimersModal } from "../../../../contexts/Disclaimers/actions"
import { DisclaimersContext } from "../../../../contexts/Disclaimers"
import React, { useContext, useEffect, useState } from "react"
import { Hotspot } from "../../XseriesModel/XseriesModel.d"
import { TabProps, Tabs } from "../../../atoms/Tabs"
import useDrag from "../../../../hooks/useDrag"
import ModelHighlightsHotspotViewer from "./ModelHighlightsHotspotViewer"
import ModelHighlightsHotspots from "./ModelHighlightsHotspots"

const ModelHighlightsModule: React.FC<ModelHighlightsModuleProps> = ({
  title,
  family,
  series,
}) => {
  const [disclaimerState, dispatch] = useContext(DisclaimersContext)
  const [activeTab, setActiveTab] = useState(0)
  return (
    <section css={[tw`max-w-[1440px] mx-auto py-20 px-10`]}>
      <h2
        css={[tw`text-3xl block leading-[104.6%] text-center mb-6 lg:text-5xl`]}
      >
        {parseDisclaimerBlocks(title, selection =>
          dispatch(toggleDisclaimersModal(selection)),
        )}
      </h2>
      <div css={[tw`min-h-screen`]}>
        <Tabs
          activeFamily={activeTab}
          families={series}
          setActiveFamily={setActiveTab}
          css={[tw`block bg-none text-xl`]}
          centerTabs={true}
        >
          {series?.map((model, index) => {
            const [currentAngleHotspots, setCurrentAngleHotspots] = useState<
              Hotspot[]
            >([])
            const [activeSpot, setActiveSpot] = useState<Hotspot>()
            const [currentAngle, setCurrentAngle] = useState<1 | 2 | 3 | 4>(1)
            const updatedExteriorImages =
              model?.modelHotspotAutoFill ||
              model?.modelSelector?.colors
                ?.find(color => color.exterior._id == model?.modelColor._id)
                ?.exteriorImages?.slice(0, 4)

            // Setting hotspots
            const angle1Hotspots = model?.hotspotsAngle1?.map(
              (hotspot: any) => {
                hotspot.angle = 1
                return hotspot
              },
            )
            const angle2Hotspots = model?.hotspotsAngle2?.map(
              (hotspot: any) => {
                hotspot.angle = 2
                return hotspot
              },
            )
            const angle3Hotspots = model?.hotspotsAngle3?.map(
              (hotspot: any) => {
                hotspot.angle = 3
                return hotspot
              },
            )
            const angle4Hotspots = model?.hotspotsAngle4?.map(
              (hotspot: any) => {
                hotspot.angle = 4
                return hotspot
              },
            )
            const hotspots = [
              ...angle1Hotspots,
              ...angle2Hotspots,
              ...angle3Hotspots,
              ...angle4Hotspots,
            ]

            useEffect(() => {
              // Setting hotspots for current angle
              let newCurrentAngleHotspots = []
              switch (currentAngle) {
                case 1:
                  newCurrentAngleHotspots = model?.hotspotsAngle1?.map(
                    (hotspot: any) => {
                      hotspot.angle = 1
                      return hotspot
                    },
                  )
                  break
                case 2:
                  newCurrentAngleHotspots = model?.hotspotsAngle2?.map(
                    (hotspot: any) => {
                      hotspot.angle = 2
                      return hotspot
                    },
                  )
                  break
                case 3:
                  newCurrentAngleHotspots = model?.hotspotsAngle3?.map(
                    (hotspot: any) => {
                      hotspot.angle = 3
                      return hotspot
                    },
                  )
                  break
                case 4:
                  newCurrentAngleHotspots = model?.hotspotsAngle4?.map(
                    (hotspot: any) => {
                      hotspot.angle = 4
                      return hotspot
                    },
                  )
                  break
                default:
                  break
              }
              setCurrentAngleHotspots(newCurrentAngleHotspots)
            }, [currentAngle])

            return (
              <Tab
                title={parseDisclaimerBlocks(
                  model.seriesRef.series.name,
                  selection => dispatch(toggleDisclaimersModal(selection)),
                )}
                key={model._key}
              >
                {updatedExteriorImages && (
                  <ModelHighlightsHotspotViewer
                    images={updatedExteriorImages}
                    currentSlideHotspots={currentAngleHotspots}
                    activeSpot={activeSpot}
                    setActiveSpot={setActiveSpot}
                    setCurrentAngle={setCurrentAngle}
                    currentAngle={currentAngle}
                    hotspots={hotspots}
                    modelData={model.modelSelector}
                  />
                )}
                {hotspots && (
                  <ModelHighlightsHotspots
                    hotspots={hotspots}
                    activeSpot={activeSpot}
                    setActiveSpot={setActiveSpot}
                    currentAngle={currentAngle}
                    setCurrentAngle={setCurrentAngle}
                  />
                )}
              </Tab>
            )
          })}
        </Tabs>
      </div>
    </section>
  )
}
export default ModelHighlightsModule

/* TAB CONTENT */
const Tab: React.FC<TabProps> = ({ children }) => {
  const { handleMouseUp } = useDrag()

  return (
    <div onMouseUp={handleMouseUp} css={[tw`mt-10`]}>
      <div css={[tw`flex flex-col gap-10 h-full w-full`]}>{children}</div>
    </div>
  )
}
